import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaWhatsapp, FaInstagram, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaLinkedinIn } from "react-icons/fa";
import TextLogo from "./TextLogo";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = "+905441354754";
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  return (
    <>
      {/* Top Bar */}
      <div className="bg-secondary text-label py-3">
        <div className="container mx-auto px-4">
          {/* Mobile Layout */}
          <div className="md:hidden">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center space-x-2 text-xs flex-wrap">
                <a href="mailto:pskyagmurdemiroz@gmail.com" className="flex items-center hover:text-primary">
                  <FaEnvelope className="mr-1" />
                  <span>Email</span>
                </a>
                <span className="text-label/50">|</span>
                <a href="tel:+905441354754" className="flex items-center hover:text-primary">
                  <FaPhoneAlt className="mr-1" />
                  <span>Nisp.</span>
                </a>
                <span className="text-label/50">|</span>
                <a href="tel:+905380792109" className="flex items-center hover:text-primary">
                  <FaPhoneAlt className="mr-1" />
                  <span>Ümran.</span>
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <a href="https://instagram.com/pskyagmurdemiroz" target="_blank" rel="noreferrer" className="hover:text-primary">
                  <FaInstagram />
                </a>
                <a href="https://linkedin.com/in/yagmurdemiroz" target="_blank" rel="noreferrer" className="hover:text-primary">
                  <FaLinkedinIn />
                </a>
              </div>
            </div>
            <div className="flex items-center justify-center space-x-2">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSewyT2vKy06Yb2oTTJUcZClAhlLeiF2S7ehXpS0RdbUK1Qkig/viewform?usp=sharing"
                target="_blank"
                rel="noreferrer"
                className="flex items-center bg-primary text-secondary px-2 py-1 rounded-md hover:opacity-90 transition-all duration-300 text-xs font-medium"
              >
                Oyun Terapisi Formu
              </a>
              <button
                onClick={handleWhatsAppClick}
                className="flex items-center bg-secondary text-label px-2 py-1 rounded-md hover:opacity-90 transition-all duration-300 text-xs font-medium"
              >
                <FaWhatsapp className="mr-1" />
                Randevu Al
              </button>
            </div>
          </div>

          {/* Desktop Layout */}
          <div className="hidden md:flex items-center justify-between">
            <div className="flex items-center space-x-4 text-sm">
              <a href="mailto:pskyagmurdemiroz@gmail.com" className="flex items-center hover:text-primary">
                <FaEnvelope className="mr-2" />
                <span>pskyagmurdemiroz@gmail.com</span>
              </a>
              <a href="tel:+905441354754" className="flex items-center hover:text-primary">
                <FaPhoneAlt className="mr-2" />
                <span>+90 544 135 47 54 (Nispetiye)</span>
              </a>
              <a href="tel:+905380792109" className="flex items-center hover:text-primary">
                <FaPhoneAlt className="mr-2" />
                <span>+90 538 079 21 09 (Ümraniye)</span>
              </a>
            </div>
            <div className="flex items-center space-x-4">
              <a href="https://instagram.com/pskyagmurdemiroz" target="_blank" rel="noreferrer" className="hover:text-primary">
                <FaInstagram />
              </a>
              <a href="https://linkedin.com/in/yagmurdemiroz" target="_blank" rel="noreferrer" className="hover:text-primary">
                <FaLinkedinIn />
              </a>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSewyT2vKy06Yb2oTTJUcZClAhlLeiF2S7ehXpS0RdbUK1Qkig/viewform?usp=sharing"
                target="_blank"
                rel="noreferrer"
                className="flex items-center bg-primary text-secondary px-3 py-1 rounded-md hover:opacity-90 transition-all duration-300 text-sm font-medium"
              >
                Oyun Terapisi Başvuru Formu
              </a>
              <button
                onClick={handleWhatsAppClick}
                className="flex items-center bg-secondary text-label px-3 py-1 rounded-md hover:opacity-90 transition-all duration-300 text-sm font-medium"
              >
                <FaWhatsapp className="mr-2" />
                Randevu Al
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="border-b bg-white border-secondary sticky w-full z-20 top-0 start-0">
        <div className="container mx-auto flex items-center justify-between p-4 py-6">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex flex-col items-start">
              <TextLogo color="secondary" />
            </Link>
          </div>

          {/* Desktop Menu - Now Right Aligned */}
          <div className="hidden md:flex items-center justify-end flex-1">
            <ul className="flex space-x-8 font-medium text-lg">
              <li>
                <Link
                  to="/"
                  className={`py-2 hover:text-secondary transition-colors ${
                    location.pathname === "/" ? "border-b border-secondary" : ""
                  }`}
                >
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link
                  to="/calisma-alanlarim"
                  className={`py-2 hover:text-secondary transition-colors ${
                    location.pathname === "/calisma-alanlarim" ? "border-b border-secondary" : ""
                  }`}
                >
                  Çalışma Alanlarım
                </Link>
              </li>
              <li>
                <Link
                  to="/hakkimda"
                  className={`py-2 hover:text-secondary transition-colors ${
                    location.pathname === "/hakkimda" ? "border-b border-secondary" : ""
                  }`}
                >
                  Hakkımda
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className={`py-2 hover:text-secondary transition-colors ${
                    location.pathname === "/blog" ? "border-b border-secondary" : ""
                  }`}
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/iletisim"
                  className={`py-2 hover:text-secondary transition-colors ${
                    location.pathname === "/iletisim" ? "border-b border-secondary" : ""
                  }`}
                >
                  İletişim
              </Link>
              </li>
            </ul>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden inline-flex items-center p-2 text-gray-500 rounded-lg hover:bg-gray-100"
          >
            <span className="sr-only">Open main menu</span>
            <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`md:hidden ${isOpen ? "block" : "hidden"} w-full px-5 pb-3`}>
          <ul className="flex flex-col p-4 font-semibold text-lg border-t border-gray-100 rounded-lg text-label bg-secondary">
            <li>
              <Link
                to="/"
                onClick={toggleMenu}
                className={`block py-2 px-3 rounded transition-colors ${
                  location.pathname === "/" ? "text-primary" : ""
                }`}
              >
                Ana Sayfa
              </Link>
            </li>
            <li>
              <Link
                to="/calisma-alanlarim"
                onClick={toggleMenu}
                className={`block py-2 px-3 rounded transition-colors ${
                  location.pathname === "/calisma-alanlarim" ? "text-primary" : ""
                }`}
              >
                Çalışma Alanlarım
              </Link>
            </li>
            <li>
              <Link
                to="/hakkimda"
                onClick={toggleMenu}
                className={`block py-2 px-3 rounded transition-colors ${
                  location.pathname === "/hakkimda" ? "text-primary" : ""
                }`}
              >
                Hakkımda
              </Link>
            </li>
            <li>
              <Link
                to="/blog"
                onClick={toggleMenu}
                className={`block py-2 px-3 rounded transition-colors ${
                  location.pathname === "/blog" ? "text-primary" : ""
                }`}
              >
                Blog
              </Link>
            </li>
            <li>
              <Link
                to="/iletisim"
                onClick={toggleMenu}
                className={`block py-2 px-3 rounded transition-colors ${
                  location.pathname === "/iletisim" ? "text-primary" : ""
                }`}
              >
                İletişim
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;